import { ApiResult, request, safeRequest } from '@synergy/api';

import { ProductDetail } from '../product-detail/overview/models/product-detail';
import { ProductDetailApi } from '../product-detail/api/product-detail-api';
import { ProductListApi } from '../product-list/api/product-api';

export class ProductApi {
    constructor(protected baseUrl: string) {
        this.listItems = new ProductListApi(this.baseUrl);
        this.detail = new ProductDetailApi(this.baseUrl);
    }

    public listItems: ProductListApi;
    public detail: ProductDetailApi;

    public duplicate(id: number): Promise<ApiResult<ProductDetail>> {
        return safeRequest(
            () => request.post(`${this.baseUrl}/products/${id}/copy`),
            response => response.data
        );
    }
}
